export default {
  title: "Related Linehauls",
  title_placeholder_empty: "There aren’t grouped linehauls",
  subtitle_placeholder_empty: "All grouped linehauls will be shown here",
  title_related_placeholder_empty: "There aren’t related linehauls",
  subtitle_related_placeholder_empty:
    "All related linehauls will be shown here",
  grouped: "Grouped",
  related: "Related",
};
